<template>
  <div class="coupon-content">
    <div class="coupon-content-scroll">
      <div class="coupon-type">
        <span class="coupon-type-name">
          クーポン使用可能
          <span class="coupon-type-total">({{ enableCouponList.length }})</span>
        </span>
        <span class="coupon-type-tip">
          *1回の注文につき1枚のみ
        </span>
      </div>
      <template v-if="enableCouponList.length">
        <coupon-item
          v-for="item in enableCouponList"
          :key="item.COUPON_ID"
          :info="item"
          :active="activeCoupon && item.COUPON_ID == activeCoupon.COUPON_ID"
          @chooseCoupon="chooseCoupon"
        ></coupon-item>
      </template>
      <template v-else>
        <coupon-item :isEmpty="true"></coupon-item>
      </template>
      <div class="coupon-type">
        <span class="coupon-type-name">
          使用不可クーポン
          <span class="coupon-type-total">({{ invalidCouponTotal }})</span>
        </span>
      </div>
      <template v-if="invalidCouponTotal > 0">
        <coupon-item
          v-for="item in disableCouponList"
          :key="item.COUPON_ID"
          :info="item"
          :invalid="true"
        ></coupon-item>
        <coupon-item
          v-for="item in expireCouponList"
          :key="item.COUPON_ID"
          :info="item"
          :invalid="true"
        ></coupon-item>
      </template>
      <template v-else>
        <coupon-item :isEmpty="true" :invalid="true"></coupon-item>
      </template>
    </div>
    <div class="coupon-use" @click="updateActiveCoupon">
      確定
    </div>
  </div>
</template>

<script>
  import CouponItem from './CouponItem.vue'

  export default {
    name: 'couponListPopup',
    props: [
      'enableCouponList',
      'disableCouponList',
      'expireCouponList',
      'defaultCoupon',
    ],
    data() {
      return {
        activeCoupon: '',
      }
    },
    computed: {
      invalidCouponTotal() {
        return this.disableCouponList.length + this.expireCouponList.length
      },
    },
    created() {
      this.defaultCoupon
        ? (this.activeCoupon = this.defaultCoupon)
        : this.autoSelectFirstCoupon()
    },
    methods: {
      hidePopup() {
        this.$emit('closeCouponSelect')
      },
      chooseCoupon(couponItem) {
        if(couponItem && this.activeCoupon) {
          this.activeCoupon =
            this.activeCoupon.COUPON_ID === couponItem.COUPON_ID
              ? null
              : couponItem
          return;
        }
        this.activeCoupon = couponItem;
      },
      updateActiveCoupon() {
        this.$emit('changeSelectedCoupon', this.activeCoupon)
        this.hidePopup()
      },
      autoSelectFirstCoupon() {
        this.activeCoupon =
          this.enableCouponList && this.enableCouponList.length
            ? this.enableCouponList[0]
            : ''
      },
    },
    components: {
      CouponItem,
    },
  }
</script>

<style scoped lang="scss">
  .coupon {
    --coupon-popup-type-title: #64563c;
    --coupon-popup-tip: #90352b;

    &-content {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 800vh;
      &-scroll {
        overflow: -moz-scrollbars-none;
        overflow-y: scroll;
        position: relative;
        height: 740vh;
        margin-bottom: 20vh;
        -ms-overflow-style: none;
        scrollbar-width: none;
        // &::-webkit-scrollbar {
        //   display: none;
        //   width: 0 !important;
        // }
        &::-webkit-scrollbar {
          width: 10vh;
          background-color: #eee;
        }
        &::-webkit-scrollbar-track {
          background-color: #eee;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #d670e1;
          border-radius: 10vh;
        }
      }
    }
    &-type {
      display: flex;
      justify-content: space-between;
      width: 467vh;
      margin: 22vh auto 12vh;
      font-size: 20vh;
      color: var(--coupon-popup-type-title);
      &:nth-child(1) {
        margin-top: 0;
      }
      &-name,
      &-tip {
        font-size: 14vh;
        font-weight: bold;
      }
      &-tip {
        color: var(--coupon-popup-tip);
      }
    }
    &-item {
      width: 467vh;
      margin: 0 auto 12vh;
    }
    &-use {
      height: 46vh;
      background-color: #d670e1;
      line-height: 46vh;
      font-size: 22vh;
      text-align: center;
      color: #fff;
      cursor: pointer;
      border-radius: 23vh;
    }
  }
</style>
